import { Directive, ElementRef, inject, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[labelRequired]',
})
export class LabelRequiredDirective implements OnInit {
  #el = inject(ElementRef);
  #renderer = inject(Renderer2);

  ngOnInit() {
    const span = this.#renderer.createElement('span');
    const text = this.#renderer.createText(' - Requis');

    this.#renderer.appendChild(span, text);

    this.#renderer.addClass(span, 'component-small-medium');
    this.#renderer.addClass(span, 'text-components-content-neutral-secondary');
    this.#renderer.addClass(span, 'group/field-label');
    this.#renderer.addClass(span, 'group-has-[:disabled]/field:text-components-content-neutral-quaternary');

    this.#renderer.appendChild(this.#el.nativeElement, span);
  }
}
